import React, { useEffect, useState } from "react";
import MA from "../assets/images/Pub/Group 2610.jpeg";
import Carrousel from "./carrousel";
import PubShimmer from "./loading/PubShimmer";

function Pub() {
  const [loading, setLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setLoading(false);
      setTimeout(() => setIsVisible(true), 100);
    };

    img.onerror = () => {
      console.error("Erreur lors du chargement de l'image MA");
      setLoading(false);
      setIsVisible(true);
    };

    img.src = MA;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, []);

  if (loading) {
    return <PubShimmer />;
  }

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50"
      id="pub"
    >
      <div className="container mx-auto px-4 py-12 lg:px-[5%]">
        <div
          className={`flex flex-col lg:flex-row gap-8 items-center transform transition-all duration-1000 ease-out
                        ${
                          isVisible
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-10"
                        }`}
        >
          {/* Section de gauche - Image */}
          <div className="w-full lg:w-1/3 flex justify-center items-center">
            <div className="relative group">
              <div className="absolute inset-0 bg-radar-700/10 rounded-2xl transform -rotate-6 scale-105 transition-transform group-hover:rotate-0 group-hover:scale-100"></div>
              <img
                src={MA}
                loading="lazy"
                className="w-full h-auto max-h-[500px] object-contain rounded-2xl transform transition-all duration-300 group-hover:scale-105"
                alt="Teamwork illustration représentant la collaboration."
              />
            </div>
          </div>

          {/* Section de droite - Texte */}
          <div className="w-full lg:w-2/3 p-6 lg:p-8">
            <div className="space-y-6">
              <h1 className="text-radar-700 font-bold text-3xl lg:text-4xl mb-8 relative">
                À propos
                <span className="absolute bottom-0 left-0 w-20 h-1 bg-radar-700 rounded-full"></span>
              </h1>

              <div className="space-y-6">
                <p className="text-radar-800 leading-normal ">
                  Ce site dédié à la télédétection radar a été créé en août
                  2024, à l'initiative de <b>Jean-Paul Rudant</b>, Professeur à
                  l'Université Gustave Eiffel et son équipe:
                  <b>
                    {" "}
                    Dinah, Erica, Faneva, Rebecca, Baovola et Valerien </b>, avec l'appui du <b> Docteur Arisetra,
                  </b>{" "}
                  de l'École de Management et d'Innovation Technologique,
                  Université de Fianarantsoa.
                </p>

                <blockquote className="relative p-6 my-8 bg-radar-50 rounded-2xl shadow-sm">
                  <div className="absolute top-0 left-0 transform -translate-y-1/2 translate-x-4">
                    <svg
                      width="45"
                      height="36"
                      className="text-radar-700 opacity-20"
                    >
                      <path
                        d="M13.415.001C6.07 5.185.887 13.681.887 23.041c0 7.632 4.608 12.096 9.936 12.096 5.04 0 8.784-4.032 8.784-8.784 0-4.752-3.312-8.208-7.632-8.208-.864 0-2.016.144-2.304.288.72-4.896 5.328-10.656 9.936-13.536L13.415.001zm24.768 0c-7.2 5.184-12.384 13.68-12.384 23.04 0 7.632 4.608 12.096 9.936 12.096 4.896 0 8.784-4.032 8.784-8.784 0-4.752-3.456-8.208-7.776-8.208-.864 0-1.872.144-2.16.288.72-4.896 5.184-10.656 9.792-13.536L38.183.001z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <p className="text-radar-pub text-lg italic leading-relaxed text-justify pl-4">
                    Notre mission est de rendre accessible l'apprentissage du
                    traitement d'image radar à travers des cours pratiques et
                    détaillés, disponibles en malgache et en français. Nous vous
                    guidons pas à pas pour maîtriser les techniques avancées et
                    les applications réelles de cette technologie puissante.
                    Nous avons ajouté quelques ressources sur le LIDAR, système
                    d'observation dont le mode de fonctionnement possède de
                    nombreux points communs avec le RADAR. Ces ressources
                    incluent un cours de l'ENSG et un documentaire
                    universitaire.
                  </p>
                </blockquote>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`mt-16 transition-all duration-1000 delay-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <Carrousel />
        </div>
      </div>
    </div>
  );
}

export default Pub;
